
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as entity from '../entity'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {ClientReportGetResponse} from './ClientReportGetResponse';

/**
 * ClientReportGetRequest struct
 */
class ClientReportGetRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!number=} login
   * @param {!string=} reportFilePath
   * @constructor
   */
  constructor (parent = new Request(), login = new UInt64(0, 0), reportFilePath = '') {
    super()
    super.copy(parent)
    this.Login = login
    this.ReportFilePath = reportFilePath
  }

  /**
   * Copy struct (shallow copy)
   * @this {!ClientReportGetRequest}
   * @param {!ClientReportGetRequest} other Other struct
   * @returns {!ClientReportGetRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Login != null) {
      this.Login = UInt64.fromNumber(other.Login)
    } else {
      this.Login = null
    }
    if (other.ReportFilePath != null) {
      this.ReportFilePath = other.ReportFilePath
    } else {
      this.ReportFilePath = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!ClientReportGetRequest}
   * @returns {!ClientReportGetRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new ClientReportGetRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new ClientReportGetRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!ClientReportGetRequest}
   * @param {!ClientReportGetRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof ClientReportGetRequest)) {
      throw new TypeError('Instance of ClientReportGetRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!ClientReportGetRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Login: ((this.Login != null) ? this.Login.toNumber() : null),
      ReportFilePath: ((this.ReportFilePath != null) ? this.ReportFilePath : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return ClientReportGetRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!ClientReportGetRequest} other Object value
   * @returns {!ClientReportGetRequest} Created struct
   */
  static fromObject (other) {
    return new ClientReportGetRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!ClientReportGetRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return ClientReportGetRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!ClientReportGetRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 3016
  }
}

export { ClientReportGetRequest };

/**
 * Fast Binary Encoding ClientReportGetRequest field model
 */
class FieldModelClientReportGetRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.Login = new fbe.FieldModelUInt64(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.ReportFilePath = new fbe.FieldModelString(buffer, this.Login.fbeOffset + this.Login.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Login.fbeSize + this.ReportFilePath.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Login.fbeExtra + this.ReportFilePath.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelClientReportGetRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 3016
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelClientReportGetRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelClientReportGetRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Login.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Login.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.ReportFilePath.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ReportFilePath.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReportFilePath.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelClientReportGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelClientReportGetRequest}
   * @param {!ClientReportGetRequest} fbeValue Default value, defaults is new ClientReportGetRequest()
   * @returns {!ClientReportGetRequest} ClientReportGetRequest value
   */
  get (fbeValue = new ClientReportGetRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelClientReportGetRequest}
   * @param {!ClientReportGetRequest} fbeValue ClientReportGetRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Login.fbeSize) <= fbeStructSize) {
      fbeValue.Login = this.Login.get()
    } else {
      fbeValue.Login = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Login.fbeSize

    if ((fbeCurrentSize + this.ReportFilePath.fbeSize) <= fbeStructSize) {
      fbeValue.ReportFilePath = this.ReportFilePath.get()
    } else {
      fbeValue.ReportFilePath = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ReportFilePath.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelClientReportGetRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelClientReportGetRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelClientReportGetRequest}
   * @param {!ClientReportGetRequest} fbeValue ClientReportGetRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelClientReportGetRequest}
   * @param {ClientReportGetRequest} fbeValue ClientReportGetRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Login.set(fbeValue.Login)
    this.ReportFilePath.set(fbeValue.ReportFilePath)
  }
}

export { FieldModelClientReportGetRequest };

/**
 * Fast Binary Encoding ClientReportGetRequest model
 */
class ClientReportGetRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelClientReportGetRequest(this.buffer, 4)
  }

  /**
   * Get the ClientReportGetRequest model
   * @this {!ClientReportGetRequestModel}
   * @returns {!FieldModelClientReportGetRequest} model ClientReportGetRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!ClientReportGetRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!ClientReportGetRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return ClientReportGetRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!ClientReportGetRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelClientReportGetRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!ClientReportGetRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!ClientReportGetRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!ClientReportGetRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!ClientReportGetRequestModel}
   * @param {!ClientReportGetRequest} value ClientReportGetRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!ClientReportGetRequestModel}
   * @param {!ClientReportGetRequest} value ClientReportGetRequest value, defaults is new ClientReportGetRequest()
   * @return {!object} Deserialized ClientReportGetRequest value and its size
   */
  deserialize (value = new ClientReportGetRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new ClientReportGetRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new ClientReportGetRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!ClientReportGetRequestModel}
   * @param {!number} prev Previous ClientReportGetRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { ClientReportGetRequestModel };
ClientReportGetRequest.__has_response = true;
ClientReportGetRequest.__response_class = ClientReportGetResponse;
